<div class="row">
  <div class="col-xs-12">
    <div class="display-flex-space-between">
      <div class="" style="flex: 0 0 80px">
        <div class="small background2-icon">
          {{ 'PARTECIPANT_LTI.RESULTS.SELECT_YEAR' | translate }}
        </div>
        <select
          id="selectYearEl"
          class="form-control"
          name="sel-activity"
          [(ngModel)]="currentYear"
        >
          <option *ngFor="let year of getYears()" [ngValue]="year">
            {{ year }}
          </option>
        </select>
      </div>
      <div class="">
        <span class="bold pointer" (click)="onRestore()">
          {{
            'PARTECIPANT_LTI.BONUS_SIMULATION.RESTORE_TARGET_VALUES' | translate
          }}
        </span>
      </div>
    </div>
  </div>
</div>

<div class="spacer"></div>

<div class="row">
  <div class="col-xs-12">
    <div class="widgetBody">
      <div class="container simulationContainer" id="wid">
        <div class="widgetHeaderInfo">
          <div class="medium widgetTitle">
            {{
              'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TITLE' | translate
            }}
          </div>
          <div class="huge widgetAmount">
            {{ formatCurrency(getAmount('accrued'), 0) }}
          </div>
        </div>

        <div class="separator_v hide-on-mobile"></div>

        <div class="">
          <div class="widgetProgressAccrued">
            <progressbar
              type="warning"
              [value]="getAmount('accrued')"
              [max]="getAmount('accrued_max')"
            ></progressbar>
          </div>
          <div class="spaceryellow"></div>
          <div class="display-flex-center" id="accruedCollapsedDetails">
            <div class="accruedCollapsedDetailsItem">
              <div class="medium accruedCollapsedDetailsAmount">
                {{ formatCurrency(getAmount('accrued_payable'), 0) }}
              </div>
              <div class="small">
                {{
                  'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.PAYABLE'
                    | translate
                }}
              </div>
            </div>
            <div class="separator_v"></div>
            <div class="accruedCollapsedDetailsItem">
              <div class="medium accruedCollapsedDetailsAmount">
                {{ formatCurrency(getAmount('accrued_deferred'), 0) }}
              </div>
              <div class="small">
                {{
                  'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.DEFERRED'
                    | translate
                }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="spacer"></div>
      <div class="spaceryellow"></div>
      <div class="spacer"></div>

      <div class="simulationContainer">
        <div class="display-flex-center flex-wrap">
          <div
            class="simulationPlan"
            *ngIf="simulationPlan.Gateways.length > 0"
          >
            <div class="simulationPlanTitle">
              {{ 'ADMIN_LTI.GATEWAYS.BODY.GATEWAYS' | translate }}
            </div>
            <ng-container *ngFor="let item of simulationPlan.Gateways">
              <div>
                <div class="display-flex-space-between flex-align-center">
                  {{ item.Goal.Name }}
                  <div>
                    &nbsp;
                    <input
                      type="number"
                      [(ngModel)]="item[currentYear].SimulatedValue"
                    />
                    &nbsp;
                    {{ getMeasure(item) }}
                  </div>
                </div>
                <nouislider
                  [step]="1"
                  [connect]="'lower'"
                  [min]="GetSliderMin(item, currentYear)"
                  [max]="GetSliderMax(item, currentYear)"
                  [(ngModel)]="item[currentYear].SimulatedValue"
                  (ngModelChange)="onChange(item)"
                ></nouislider>
              </div>
            </ng-container>
          </div>
          <div
            class="simulationPlan"
            *ngIf="simulationPlan.Objectives.length > 0"
          >
            <div class="simulationPlanTitle">
              {{ 'ADMIN_LTI.GATEWAYS.BODY.OBJECTIVES' | translate }}
            </div>
            <ng-container *ngFor="let item of simulationPlan.Objectives">
              <div>
                <div class="display-flex-space-between flex-align-center">
                  {{ item.Goal.Name }}
                  <div>
                    &nbsp;
                    <input
                      type="number"
                      [(ngModel)]="item[currentYear].SimulatedValue"
                    />
                    &nbsp;
                    {{ getMeasure(item) }}
                  </div>
                </div>
                <nouislider
                  [step]="1"
                  [connect]="'lower'"
                  [min]="GetSliderMin(item, currentYear)"
                  [max]="GetSliderMax(item, currentYear)"
                  [(ngModel)]="item[currentYear].SimulatedValue"
                  (ngModelChange)="onChange(item)"
                ></nouislider>
              </div>
            </ng-container>
          </div>
          <div
            class="simulationPlan"
            *ngIf="simulationPlan.Correctives.length > 0"
          >
            <div class="simulationPlanTitle">
              {{ 'ADMIN_LTI.GATEWAYS.BODY.CORRECTIVE' | translate }}
            </div>
            <ng-container *ngFor="let item of simulationPlan.Correctives">
              <div>
                <div class="display-flex-space-between flex-align-center">
                  {{ item.Goal.Name }}
                  <div>
                    &nbsp;
                    <input
                      type="number"
                      [(ngModel)]="item[currentYear].SimulatedValue"
                    />
                    &nbsp;
                    {{ getMeasure(item) }}
                  </div>
                </div>
                <nouislider
                  [step]="1"
                  [connect]="'lower'"
                  [min]="GetSliderMin(item, currentYear)"
                  [max]="GetSliderMax(item, currentYear)"
                  [(ngModel)]="item[currentYear].SimulatedValue"
                  (ngModelChange)="onChange(item)"
                ></nouislider>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
